import { z } from 'zod';
/**
 * The cost currencies the exchange-rates cron fetches. LOCKSTEP: the
 * skus_sku_cost_override_currency_supported CHECK and the currency list of
 * base_garment_update_grid. A leaf module, so `inventory.ts` and
 * `base-garments.ts` (which import each other's neighbours) can both read it.
 */
export const costCurrencySchema = z.enum(['AUD', 'USD', 'CNY', 'EUR', 'GBP']);
